import { render, staticRenderFns } from "./qnaAnalytics.vue?vue&type=template&id=550b2977&scoped=true"
import script from "./qnaAnalytics.vue?vue&type=script&lang=js"
export * from "./qnaAnalytics.vue?vue&type=script&lang=js"
import style0 from "./qnaAnalytics.vue?vue&type=style&index=0&id=550b2977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b2977",
  null
  
)

export default component.exports